import React, { useEffect, useState } from 'react';
import { _axios as axios, cancelToken, customFetch } from '../../utils/auth';
import SearchBarComponent from '../../components/SearchBar/SearchBar';
import SearchList from '../../components/SearchList/SearchList';
import { url } from '../../utils';
import './Search.css';
import { useParams } from 'react-router-dom';

interface List {
  label: string;
  link: string;
}

interface ListSearchDistanceType {
  onKeyword: List;
  project?: Array<List>;
  recommended?: Array<List>;
  mall?: Array<List>;
  university?: Array<List>;
  hospital?: Array<List>;
  popular_area?: Array<List>;
  road?: Array<List>;
  airport?: Array<List>;
  train?: Array<List>;
  park?: Array<List>;
  location_type?: Array<List>;
}

interface ListSearchNameType {
  list_actions: Array<List>;
  phrase_match?: Array<List>;
}

const useDebounceValue = (value: string) => {
  const [deBouncedValue, setDeBounceValue] = useState(value);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDeBounceValue(value);
    }, 300);

    return () => clearTimeout(timeout);
  }, [value]);

  return deBouncedValue;
};

const Search = () => {
  const { language } = useParams();
  const [keyword, setKeyword] = useState<string>('');
  const [listSearchDistance, setlistSearchDistance] = useState<ListSearchDistanceType>();
  const [listSearchName, setlistSearchName] = useState<ListSearchNameType>();
  const finalKeyword = useDebounceValue(keyword);

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      console.log('Body height changed:', entries[0].target.clientHeight);

      const msg = {
        target: '9assetApp',
        type: 'setheight',
        value: entries[0].target.clientHeight,
      };

      console.log('Body height changed:', msg);
      window.parent.postMessage(msg, '*');
    });

    resizeObserver.observe(document.body);
  }, []);

  useEffect(() => {
    getListSearchName();
    getListSearchDistance();
  }, [finalKeyword]);

  const getListSearchDistance = async () => {
    const response = await axios.post(
      `${url}/v1/search/distance`,
      {
        keyword: keyword,
      },
      {
        headers: {
          'Accept-Language': `${language || 'th'}`,
        },
      },
    );
    setlistSearchDistance(response.data.data);
  };

  const getListSearchName = async () => {
    const response = await axios.post(
      `${url}/v1/search/name`,
      {
        keyword: keyword,
      },
      {
        headers: {
          'Accept-Language': `${language || 'th'}`,
        },
      },
    );
    setlistSearchName(response.data.data);
  };

  const insertHistory = async (url: string) => {
    try {
      await axios.post(
        `${url}/v1/history`,
        {
          url: url,
        },
        {
          headers: {
            'Accept-Language': `${language || 'th'}`,
          },
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="search-container max-h-[842px]">
      <SearchBarComponent
        finalKeyword={finalKeyword}
        keyword={keyword}
        setKeyword={setKeyword}
        listSearchDistance={listSearchDistance}
        insertHistory={insertHistory}
      />
      <div
        className={`search-result flex flex-col gap-1 h-full max-h-[500px] md:max-h-[800px] ${
          finalKeyword ? 'border-2 rounded-b-2xl w-full bg-white overflow-y-auto' : ''
        }`}>
        {/* {finalKeyword && Boolean(listSearchDistance?.recommended?.length) && (
          <div className="px-12 text-xs text-gray-600">แนะนำ</div>
        )} */}
        {finalKeyword && Boolean(listSearchDistance?.onKeyword) && (
          <SearchList
            label={listSearchDistance?.onKeyword.label}
            link={listSearchDistance?.onKeyword.link}
            onClick={insertHistory}
            setKeyword={setKeyword}
          />
        )}
        {finalKeyword &&
          Boolean(listSearchName?.phrase_match?.length) &&
          listSearchName?.phrase_match?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword &&
          Boolean(listSearchDistance?.recommended?.length) &&
          listSearchDistance?.recommended?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword &&
          Boolean(listSearchDistance?.location_type?.length) &&
          listSearchDistance?.location_type?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.project?.length) && (
          <div className="px-12 text-xs text-gray-600">โครงการ</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.project?.length) &&
          listSearchDistance?.project?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.train?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ รถไฟฟ้า</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.train?.length) &&
          listSearchDistance?.train?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.road?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ ถนน</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.road?.length) &&
          listSearchDistance?.road?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.mall?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ ห้างสรรพสินค้า</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.mall?.length) &&
          listSearchDistance?.mall?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.university?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ มหาวิทยาลัย</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.university?.length) &&
          listSearchDistance?.university?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}

        {finalKeyword && Boolean(listSearchDistance?.hospital?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ โรงพยาบาล</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.hospital?.length) &&
          listSearchDistance?.hospital?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} setKeyword={setKeyword} onClick={insertHistory} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.park?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ สวนสาธารณะ</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.park?.length) &&
          listSearchDistance?.park?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.airport?.length) && (
          <div className="px-12 text-xs text-gray-600">ใกล้ สนามบิน</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.airport?.length) &&
          listSearchDistance?.airport?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
        {finalKeyword && Boolean(listSearchDistance?.popular_area?.length) && (
          <div className="px-12 text-xs text-gray-600">สถานที่ยอดนิยม</div>
        )}
        {finalKeyword &&
          Boolean(listSearchDistance?.popular_area?.length) &&
          listSearchDistance?.popular_area?.map((e, index) => {
            return (
              <SearchList key={index} label={e.label} link={e.link} onClick={insertHistory} setKeyword={setKeyword} />
            );
          })}
      </div>
    </div>
  );
};

export default Search;
